// import this so it's invoked
import './config';

export const LOCATION_CHANGE = '@@router/LOCATION_CHANGE';
export const LOADING = 'LOADING';
export const LOG_OUT = 'LOG_OUT';
export const UPDATE_LOCALES = 'UPDATE_LOCALES';

export const FETCH_ERROR = 'FETCH_ERROR';
export const POST_ERROR = 'POST_ERROR';
export const NOTICE_RECEIVED = 'NOTICE_RECEIVED';
export const DELETE_ERROR = 'DELETE_ERROR';
export const CLEARED_ERROR = 'CLEARED_ERROR';
export const CLEARED_NOTICE = 'CLEARED_NOTICE';
export const CLEAR_DATA = 'CLEAR_DATA';

export const STEP1_SAVE = 'STEP1_SAVE';
export const SET_PROPOSALS = 'SET_PROPOSALS';
export const ADD_INDUSTRY = 'ADD_INDUSTRY';
export const TOGGLE_DRAW_RADIUS = 'TOGGLE_DRAW_RADIUS';
export const UPDATE_INDUSTRY_AND_CLEAN_BASKET = 'UPDATE_INDUSTRY_AND_CLEAN_BASKET';
export const UPDATE_INDUSTRY = 'UPDATE_INDUSTRY';
export const UPDATE_DURATION = 'UPDATE_DURATION';
export const UPDATE_BUDGET = 'UPDATE_BUDGET';
export const UPDATE_DIGITAL = 'UPDATE_DIGITAL';
export const UPDATE_CITY_LOCATION = 'UPDATE_CITY_LOCATION ';
export const UPDATE_START_DATE = 'UPDATE_START_DATE';
export const UPDATE_DATE_ACCURACY = 'UPDATE_DATE_ACCURACY';
export const SELECT_FORMATS = 'SELECT_FORMATS';
export const SELECT_TARGETS = 'SELECT_TARGETS';
export const SELECT_ATTRIBUTES = 'SELECT_ATTRIBUTES';

export const SET_FILTERS = 'SET_FILTERS';
export const SET_RESULTS_FILTERS = 'SET_RESULTS_FILTERS';
export const SET_RESULTS_FILTERS_VISIBILITY = 'SET_RESULTS_FILTERS_VISIBILITY';

export const FETCHED_INDUSTRIES_BIG5 = 'FETCHED_INDUSTRIES_BIG5';
export const FETCHED_INDUSTRIES = 'FETCHED_INDUSTRIES';
export const FETCHED_BOOKING_DATES = 'FETCHED_BOOKING_DATES';
export const FETCHED_FILTERS = 'FETCHED_FILTERS';
export const POSSIBLE_FORMATS = 'POSSIBLE_FORMATS';
export const POST_SELECT = 'POST_SELECT';
export const ADD_LOCATION = 'ADD_LOCATION';
export const UPDATE_LOCATION = 'UPDATE_LOCATION';
export const REMOVE_LOCATION = 'REMOVE_LOCATION';
export const FETCH_LOCATION_POLYGONAL_BORDER = 'FETCH_LOCATION_POLYGONAL_BORDER';

export const CREATED_BASKET = 'CREATED_BASKET';
export const FETCHED_BASKET = 'FETCHED_BASKET';
export const FETCHED_BASKET_STATE = 'FETCHED_BASKET_STATE';
export const FETCHED_BASKETJ2 = 'FETCHED_BASKETJ2';
export const FETCHED_BASKET_DEFINITION = 'FETCHED_BASKET_DEFINITION';
export const FETCHED_BASKET_INFO = 'FETCHED_BASKET_INFO';
export const BASKET_SELECTION_UPDATED = 'BASKET_SELECTION_UPDATED';
export const CHOOSE_BASKET = 'CHOOSE_BASKET';
export const FETCHED_PROPOSALS = 'FETCHED_PROPOSALS';
export const FETCHED_BUDGETS = 'FETCHED_BUDGETS';
export const RESERVED_BASKET = 'RESERVED_BASKET';
export const FETCHED_USER_INFO = 'FETCHED_USER_INFO';
export const FETCHED_BASKET_CUSTOMER = 'FETCHED_BASKET_CUSTOMER';
export const FETCHED_PAYMENT_METHODS = 'FETCHED_PAYMENT_METHODS';
export const ADDED_VOUCHER = 'ADDED_VOUCHER';
export const DELETED_VOUCHER = 'DELETED_VOUCHER';
export const BOOKED_BASKET = 'BOOKED_BASKET';
export const BASKET_DATA_POSTED = 'BASKET_DATA_POSTED';
export const KEYCLOAK_STATE = 'KEYCLOAK_STATE';
export const GAVE_FEEDBACK = 'GAVE_FEEDBACK';
export const FETCHED_PRODUCT = 'FETCHED_PRODUCT';
export const UPDATE_ATTRIBUTES1 = 'UPDATE_ATTRIBUTES1';
export const UPDATE_ATTRIBUTES2 = 'UPDATE_ATTRIBUTES2';
export const RESET_ATTRIBUTES2 = 'RESET_ATTRIBUTES2';
export const REMOVED_FROM_BASKET = 'REMOVED_FROM_BASKET';
export const ADDED_TO_BASKET = 'ADDED_TO_BASKET';
export const EDIT_IN_BASKET = 'EDIT_IN_BASKET';
export const FETCHED_CAMPAIGN = 'FETCHED_CAMPAIGN';
export const SET_BASKET_INFO = 'SET_BASKET_INFO';

export const GET_CAMPAIGNS = 'GET_CAMPAIGNS';
export const GET_CREATION_ORDER = 'GET_CREATION_ORDER';
export const GET_PRODUCTION_ORDER = 'GET_PRODUCTION_ORDER';
export const GET_ORDER_COMPANY = 'GET_ORDER_COMPANY';
export const CHANGED_PRODUCT_DATE = 'CHANGED_PRODUCT_DATE';
export const FETCHED_PRODUCT_PRICE = 'FETCHED_PRODUCT_PRICE';
export const FETCHED_DIGITAL_PRODUCT_AVAILABILITY = 'FETCHED_DIGITAL_PRODUCT_AVAILABILITY';
export const UPDATE_DATE_DURATION = 'UPDATE_DATE_DURATION';
export const FETCHED_SHARE_OF_TIME = 'FETCHED_SHARE_OF_TIME';

export const FETCHED_CUSTOMERS = 'FETCHED_CUSTOMERS';
export const FETCHED_PRODUCT_FILTERS = 'FETCHED_PRODUCT_FILTERS';

export const SELECT_CUSTOMER = 'SELECT_CUSTOMER';

export const SET_CHOSEN_PROPOSAL = 'SET_CHOSEN_PROPOSAL';

// Checkout
export const BASKET_CUSTOMER_POSTED = 'BASKET_CUSTOMER_POSTED';
export const PAYMENT_EVENT = 'PAYMENT_EVENT';
export const STARTED_PAYMENT = 'STARTED_PAYMENT';
export const STOPPED_PAYMENT = 'STOPPED_PAYMENT';

export const SET_TYPE_CONTAINER = 'SET_TYPE_CONTAINER';

export const SET_CAMPAIGN_NAME = 'SET_CAMPAIGN_NAME';
export const SET_IS_BASKET_BOOKED = 'SET_IS_BASKET_BOOKED';
export const FETCHED_LAST_BOOKED_BASKET_INFO = 'FETCHED_LAST_BOOKED_BASKET_INFO';

// Journey 3
export const PREFILL_DATA = 'PREFILL_DATA';
export const UPDATE_LOCATION_J3 = 'UPDATE_LOCATION_J3';
export const COPIED_BASKET_J3 = 'COPIED_BASKET_J3';

export const OPEN_BASKET = 'OPEN_BASKET';
export const CLOSE_BASKET = 'CLOSE_BASKET';
export const SEARCH_RESULT = 'SEARCH_RESULT';
export const HIGHLIGHT_LOCATION = 'HIGHLIGHT_LOCATION';
export const POST_IMPORT_DATA = 'POST_IMPORT_DATA';
export const UPDATE_MAP_CENTER = 'UPDATE_MAP_CENTER';
export const SET_FASTBOOK_DATA = 'SET_FASTBOOK_DATA';
export const SET_DIGIFLEX_DATA = 'SET_DIGIFLEX_DATA';
export const CLEAR_DIGIFLEX_DATA = 'CLEAR_DIGIFLEX_DATA';
export const SET_UI_DATA = 'SET_UI_DATA';

export const CLEAR_BASKET_INFO = 'CLEAR_BASKET_INFO';
export const CLEAR_LOCATIONS = 'CLEAR_LOCATIONS';
export const SET_AGENCY_INFO_PANEL_VISIBILITY = 'SET_AGENCY_INFO_PANEL_VISIBILITY';
export const SET_IS_AGENCY_MODE = 'SET_IS_AGENCY_MODE';
export const SET_AGENCY_DATA = 'SET_AGENCY_DATA';
